import { Pipe, PipeTransform } from '@angular/core';

import { Nullish } from '../models';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | Nullish, limit: number): string {
    const trail = '…';
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
